var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import styles from './ChangeLogDialog.module.scss';
import { Api } from '@app/Api';
import { Modal } from '@app/Components/Modal/Modal';
import { convertUTCDateToLocalDate, DATE_WITH_TIME_OPTIONS } from '@app/Helpers/DateOptions';
import HTMLReactParser from 'html-react-parser';
import { Grid } from '../Grid/Grid';
import { Column } from 'devextreme-react/data-grid';
export var ChangeLogDialog = /** @class */ (function (_super) {
    __extends(ChangeLogDialog, _super);
    function ChangeLogDialog(props) {
        var _this = _super.call(this, props) || this;
        _this._store = new ChangeLogStore();
        return _this;
    }
    ChangeLogDialog.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._store.loadData(this.props.uniqueId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChangeLogDialog.prototype._onToggle = function () {
        this.props.onToggle();
    };
    ChangeLogDialog.prototype.render = function () {
        return (React.createElement("div", { className: styles.container },
            React.createElement(Modal, { isOpen: true, toggle: this._onToggle, headerTitle: "History", maxWidth: "85%", footerbuttons: this._getFooterButtons() },
                React.createElement(Grid, { dataSource: this._store.data, rowRender: DataRow, showBorders: true },
                    React.createElement(Column, { caption: "Modified", dataField: "date", cellRender: function (_a) {
                            var data = _a.data;
                            return convertUTCDateToLocalDate(data.date).toLocaleDateString('en-GB', DATE_WITH_TIME_OPTIONS);
                        } }),
                    React.createElement(Column, { caption: "Modified by", dataField: "changedBy" }),
                    React.createElement(Column, { caption: "Action", dataField: "" }),
                    React.createElement(Column, { caption: "Object", dataField: "" }),
                    React.createElement(Column, { caption: "Field", dataField: "" }),
                    React.createElement(Column, { caption: "Old Value", dataField: "" }),
                    React.createElement(Column, { caption: "New Value", dataField: "" })))));
    };
    ChangeLogDialog.prototype._getFooterButtons = function () {
        return [
            {
                onClick: this._onToggle,
                title: 'Close'
            }
        ];
    };
    __decorate([
        action.bound
    ], ChangeLogDialog.prototype, "_onToggle", null);
    ChangeLogDialog = __decorate([
        observer
    ], ChangeLogDialog);
    return ChangeLogDialog;
}(React.PureComponent));
export default function DataRow(_a) {
    var data = _a.data;
    return (React.createElement("tbody", { className: "dx-row ".concat(styles.row) },
        React.createElement("tr", { className: "main-row" },
            React.createElement("td", null, convertUTCDateToLocalDate(data.date).toLocaleDateString('en-GB', DATE_WITH_TIME_OPTIONS)),
            React.createElement("td", null, data.changedBy),
            React.createElement("td", null),
            React.createElement("td", null),
            React.createElement("td", null),
            React.createElement("td", null),
            React.createElement("td", null)),
        data.objects.map(function (object, i) { return (React.createElement(React.Fragment, null,
            React.createElement("tr", { className: "notes-row", key: i },
                React.createElement("td", null),
                React.createElement("td", null),
                React.createElement("td", { style: { borderTop: '1px solid #ddd' } }, i == 0 && object.actionType),
                React.createElement("td", { style: { borderTop: '1px solid #ddd' } }, object.objectType),
                React.createElement("td", { style: { borderTop: '1px solid #ddd' } }),
                React.createElement("td", { style: { borderTop: '1px solid #ddd' } }),
                React.createElement("td", { style: { borderTop: '1px solid #ddd' } })),
            object.fields.length !== 0 &&
                object.fields.map(function (field) { return (React.createElement("tr", { key: field.id },
                    React.createElement("td", null),
                    React.createElement("td", null),
                    React.createElement("td", null),
                    React.createElement("td", null),
                    React.createElement("td", { style: { borderBottom: '1px solid #ddd', borderTop: '1px solid #ddd' } }, field.name),
                    React.createElement("td", { style: {
                            wordBreak: 'break-all',
                            borderBottom: '1px solid #ddd',
                            borderTop: '1px solid #ddd'
                        } }, field.isDateTimeFieldType && field.oldValueDate
                        ? convertUTCDateToLocalDate(field.oldValueDate).toLocaleDateString('en-GB', DATE_WITH_TIME_OPTIONS)
                        : HTMLReactParser(field.oldValue || '')),
                    React.createElement("td", { style: {
                            wordBreak: 'break-all',
                            borderBottom: '1px solid #ddd',
                            borderTop: '1px solid #ddd'
                        } }, field.isDateTimeFieldType && field.newValueDate
                        ? convertUTCDateToLocalDate(field.newValueDate).toLocaleDateString('en-GB', DATE_WITH_TIME_OPTIONS)
                        : HTMLReactParser(field.newValue || '')))); }))); })));
}
var ChangeLogStore = /** @class */ (function () {
    function ChangeLogStore() {
    }
    ChangeLogStore.prototype.loadData = function (uniqueId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, Api.secured.getLog({ uniqueId: uniqueId })];
                    case 1:
                        _a.data = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        observable
    ], ChangeLogStore.prototype, "data", void 0);
    __decorate([
        action
    ], ChangeLogStore.prototype, "loadData", null);
    return ChangeLogStore;
}());
